import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminCatalogosContablesPage } from "@/features/admin-catalogos-contables/components/AdminCatalogosContablesPage";
import {
  cecosConOrgsAdminQueryOptions,
  cuentasAdminQueryOptions,
} from "@/features/admin-catalogos-contables/hooks/use-catalogos-contables-admin";

/**
 * Ruta `/admin/catalogos-contables` · CRUD de CeCo y Cuenta. Precarga la
 * primera página de ambos gestores (paginado server-side · debe coincidir
 * con los params iniciales de SeccionCecos/SeccionCuentas).
 */
export const Route = createFileRoute("/_authed-tw/admin/catalogos-contables")({
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion([PERMISOS.adminCatalogosContables])
      ? Promise.all([
      queryClient.ensureQueryData(cecosConOrgsAdminQueryOptions({ page: 1, pageSize: 15 })),
      queryClient.ensureQueryData(cuentasAdminQueryOptions({ page: 1, pageSize: 15 })),
    ])
      : undefined,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminCatalogosContables]}>
      <AdminCatalogosContablesPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
